import WarehouseAdminProductListData from "@/http/data/warehouse-admin-product-list-data";
import WarehouseAdminProductData from "@/http/data/warehouse-admin-product-data";
import WarehouseAdminOptionsData from "@/http/data/warehouse-admin-options-data";
import WarehouseAdminOrderData from "@/http/data/warehouse-admin-order-data";
import WarehouseAdminStockProductData from "@/http/data/warehouse-admin-stock-product-data";
import WarehouseAdminRestockData from "@/http/data/warehouse-admin-restock-data";
import WarehouseAdminRetourData from "@/http/data/warehouse-admin-retour-data";
import WarehouseAdminSupplierData from "@/http/data/warehouse-admin-supplier-data";
import WarehouseAdminSupplierInvoiceData from "@/http/data/warehouse-admin-supplier-invoice-data";
import WarehouseAdminOrderBuildingReportData from "@/http/data/warehouse-admin-order-building-report-data";
import WarehouseAdminDeliveredTotalsByBuildingReportData from "@/http/data/warehouse-admin-delivered-totals-by-building-report-data";
import WarehouseAdminSimpleProductReportData from "@/http/data/warehouse-admin-simple-product-report-data";
import WarehouseAdminDeliveredTotalsByPeriodReportData from "@/http/data/warehouse-admin-delivered-totals-by-period-report-data";
import WarehouseAdminResupplyTaskData from "@/http/data/warehouse-admin-resupply-task-data";

export enum WarehouseAdminStatus {
    Failed = "failed",
    Unauthenticated = "unauthenticated",
    Forbidden = "forbidden",
    Empty = "empty",
    Loading = "loading",
    Ready = "ready"
}

export default class WarehouseAdminState {
    products: WarehouseAdminProductListData[] = [];
    product: WarehouseAdminProductData|null = null;
    options: WarehouseAdminOptionsData|null = null;
    orders: WarehouseAdminOrderData[] = [];
    order: WarehouseAdminOrderData|null = null;
    stock: WarehouseAdminStockProductData[] = [];
    stockBuilding: string|null = null;
    restocks: WarehouseAdminRestockData[] = [];
    retours: WarehouseAdminRetourData[] = [];
    restockHistory: WarehouseAdminRestockData[] = [];
    suppliers: WarehouseAdminSupplierData[] = [];
    supplierInvoices: WarehouseAdminSupplierInvoiceData[] = [];
    supplierInvoicesSupplierId: number|null = null;
    orderBuildingReport: WarehouseAdminOrderBuildingReportData|null = null;
    deliveredTotalsByBuildingReport: WarehouseAdminDeliveredTotalsByBuildingReportData|null = null;
    simpleProductReport: WarehouseAdminSimpleProductReportData|null = null;
    deliveredTotalsByPeriodReport: WarehouseAdminDeliveredTotalsByPeriodReportData|null = null;
    resupplyTasks: WarehouseAdminResupplyTaskData[] = [];

    productsStatus = WarehouseAdminStatus.Failed;
    productStatus = WarehouseAdminStatus.Failed;
    optionsStatus = WarehouseAdminStatus.Failed;
    ordersStatus = WarehouseAdminStatus.Failed;
    orderStatus = WarehouseAdminStatus.Failed;
    stockStatus = WarehouseAdminStatus.Failed;
    restocksStatus = WarehouseAdminStatus.Failed;
    retoursStatus = WarehouseAdminStatus.Failed;
    restockHistoryStatus = WarehouseAdminStatus.Failed;
    supplierInvoicesStatus = WarehouseAdminStatus.Empty;
    suppliersStatus = WarehouseAdminStatus.Failed;
    orderBuildingReportStatus = WarehouseAdminStatus.Empty;
    deliveredTotalsByBuildingReportStatus = WarehouseAdminStatus.Empty;
    simpleProductReportStatus = WarehouseAdminStatus.Empty;
    deliveredTotalsByPeriodReportStatus = WarehouseAdminStatus.Empty;
    resupplyTasksStatus = WarehouseAdminStatus.Empty;

    isSaving = false;
    isInitialized = false;
}